import React from "react";
import { Link } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiPhone, mdiWhatsapp } from "@mdi/js";
import { useSite } from "../theme/ThemeProvider";

const CtaBand = ({ title = "Aracınız için teklif alın", text = "Aracınızın marka ve modelini yazın, aynı gün fiyat ve randevu bilgisi iletelim." }) => {
  const site = useSite();
  return (
    <section className="section section--tight">
      <div className="container">
        <div className="cta-band">
          <div>
            <h2>{title}</h2>
            <p>{text}</p>
          </div>
          <div className="cta-band__actions">
            <Link to="/iletisim" className="btn btn--light btn--lg">
              Teklif formu
            </Link>
            <a href={`tel:${site.phoneHref}`} className="btn btn--outline-light btn--lg">
              <Icon path={mdiPhone} /> Ara
            </a>
            <a href={`https://wa.me/${site.whatsapp}`} target="_blank" rel="noreferrer" className="btn btn--outline-light btn--lg">
              <Icon path={mdiWhatsapp} /> WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
